import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.boletimbackup.cadastra(payload).then(res => {
        dispatch('ActionSetBoletim',res)
    }).catch(err => {
        dispatch('ActionSetBoletim',err)
    })
}


export const ActionSetBoletim = ({commit},payload) =>{
    commit(types.SET_BOLETIM,payload)
}


